import { render } from "./HeaderTasksInProgress.vue?vue&type=template&id=243c37c7&scoped=true"
import script from "./HeaderTasksInProgress.vue?vue&type=script&lang=js"
export * from "./HeaderTasksInProgress.vue?vue&type=script&lang=js"

import "./HeaderTasksInProgress.vue?vue&type=style&index=0&id=243c37c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243c37c7"]])

export default __exports__